import { useRef, useState } from 'react';
import { Selection } from 'react-aria-components';

import ChevronIcon from '@/fo/icons/base/icons/chevron24.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';
import { UiKitListboxBase } from '@/fo/ui/kit/listbox/base';
import { useMediaQuery } from '@/fo/ui/mod/media/query';

import { FilterOption } from '../../types';

import { styles } from './SortBlock.styles';

export interface SortBlockProps {
  sortByFilters: FilterOption[];
  selectedSortByFilters: string;
  onSortChange: (option: FilterOption | null) => void;
}
export function SortBlock({
  sortByFilters = [],
  selectedSortByFilters = '',
  onSortChange
}: SortBlockProps) {
  const slots = styles();
  const isDesktop = useMediaQuery('sm');
  const [open, setOpen] = useState(false);

  const selected =
    sortByFilters.find((s) => s.value === selectedSortByFilters) ||
    sortByFilters[0];

  const triggerRef = useRef<HTMLButtonElement>(null);

  const handleSortChange = (value: Selection) => {
    if (value === 'all') {
      return;
    }

    const selectedOption = sortByFilters.find(
      (option) => option.value === Array.from(value)[0]
    );

    onSortChange?.(selectedOption as FilterOption);
    setOpen(false);
  };

  if (isDesktop) {
    return (
      <div>
        <button
          ref={triggerRef}
          className={slots.sortButton()}
          onClick={() => setOpen(!open)}
        >
          {
            sortByFilters.find(
              (option) => option.value === selectedSortByFilters
            )?.label
          }
          <ChevronIcon className={slots.sortButtonIcon({ open })} />
        </button>
        <UiKitListboxBase
          isOpen={open}
          triggerRef={triggerRef}
          placement="bottom right"
          offset={4}
          crossOffset={12}
          options={sortByFilters}
          onSelectionChange={handleSortChange}
          width="225px"
          onOpenChange={setOpen}
        />
      </div>
    );
  }

  return (
    <UiKitDrawerBase
      title={selected.label}
      open={open}
      trigger={
        <button
          ref={triggerRef}
          className={slots.sortButton()}
        >
          {
            sortByFilters.find(
              (option) => option.value === selectedSortByFilters
            )?.label
          }
          <ChevronIcon className={slots.sortButtonIcon({ open })} />
        </button>
      }
      onOpenChange={setOpen}
    >
      <ul>
        {sortByFilters.map((option) => (
          <li key={option.value}>
            <UiKitButtonBase
              className={slots.button()}
              color="ghost"
              onClick={() => {
                onSortChange(option);
                setOpen(false);
              }}
            >
              {option.label}
            </UiKitButtonBase>
          </li>
        ))}
      </ul>
    </UiKitDrawerBase>
  );
}
